import { isString } from "@studiometa/js-toolkit/utils";
import htmlLoader from "@studiometa/playground/html-loader.js";
import styleLoader from "@studiometa/playground/style-loader.js";
import scriptLoader from "@studiometa/playground/script-loader.js";
const store = {
  defaults: {
    html: "",
    style: "",
    script: ""
  },
  loaders: {
    html: htmlLoader,
    style: styleLoader,
    script: scriptLoader
  }
};
function setDefaults(defaults) {
  store.defaults = {
    ...store.defaults,
    ...defaults
  };
}
function setConfig(config) {
  setDefaults(config?.defaults);
  store.loaders = {
    ...store.loaders,
    ...config?.loaders
  };
}
async function getDefault(type) {
  console.log("getDefault", type);
  const defaultContent = store.defaults[type];
  if (isString(defaultContent)) {
    return defaultContent;
  }
  return defaultContent();
}
async function getDefaultHtml() {
  return getDefault("html");
}
async function getDefaultStyle() {
  return getDefault("style");
}
async function getDefaultScript() {
  return getDefault("script");
}
function getHtmlLoader() {
  return store.loaders.html;
}
function getStyleLoader() {
  return store.loaders.style;
}
function getScriptLoader() {
  return store.loaders.script;
}
export {
  getDefaultHtml,
  getDefaultScript,
  getDefaultStyle,
  getHtmlLoader,
  getScriptLoader,
  getStyleLoader,
  setConfig,
  setDefaults
};
//# sourceMappingURL=config.js.map
